import React, { useEffect, useState } from 'react';
import Link from "next/link";
import ClipLoader from "react-spinners/ClipLoader";
import cookies from 'next-cookies';
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import MainLayout from "../../Layouts/MainLayout";
import MainButton from "../../components/ButtonsCont/MainButton";
import TextInput from "../../components/TextInput/TextInput";
import NumberInput from "../../components/TextInput/NumberInput";
import PhoneInputComponent from "../../components/TextInput/PhoneInput";
import validation from "../../utils/validation";
import hooks from "../../hooks/cardHook";
import styles from '../../styles/PaymentCards.module.scss';
import { wrapper } from '../../store';
export const getServerSideProps = wrapper.getServerSideProps(async (ctx) => {
    const { token, master } = cookies(ctx);
    if (!token) {
        return { props: { loggedIn: false } };
    }
    return {
        props: {
            token: token || null,
            loggedIn: true,
            stripe: ctx.query.stripe ? ctx.query.stripe : null,
            status: ctx.query.status ? ctx.query.status : null,
            master: master || null,
            language: ctx.locale,
            ...(await serverSideTranslations(ctx.locale, ["common"])),
        }
    };
});
function AddCard(props) {
    const {
        card_list,
        translate,
        router,
        activeInput,
        user,
        focus,
        setActive,
        create_account,
        add_card,
        card_input,
        keyPress,
        setFocus
    } = hooks(props);

    useEffect(() => {
        card_input({
            key: "phone_number",
            value: validation({ currentCode: 'FR', value: '+33', type: "phone_number" })
        });
    }, []);
    const { t } = useTranslation();

    return (
        // <div className="App">
        <MainLayout
            language={props.language}
            meta={t("add_card_descriptions")}
            title={t("title")}
            token={props.token}
            id={user ? user.id : ""}
            user_image={user ? user.image : ""}
        >
            <main className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link href={`/${props.language}`}>
                                <a>{t("main")}</a>
                            </Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            <Link href={`/${props.language}/payment-cards`}>
                                <a>{t("paymentCardLabel")}</a>
                            </Link>
                        </li>
                        <li className="breadcrumb-item active"
                            aria-current="page">{t("addCardLabel")}</li>
                    </ol>
                </nav>
                <div className={`add-cards ${styles.add_cards}`}>
                    <div className={activeInput === 1
                        ? "active-input_card active-firstinput_card"
                        : styles.input_icons}>
                        <div className="add-icon-card">
                            <span className="icon-credit-card">
                                <span className="path1"></span>
                                <span className="path2"></span>
                                <span className="path3"></span>
                                <span className="path4"></span>
                                <span className="path5"></span>
                                <span className="path6"></span>
                            </span>
                        </div>
                        <NumberInput
                            isCardInput={true}
                            first_childe={true}
                            placeholder={t("cardNumberLabel")}
                            focused={activeInput === 1}
                            onKeyDown={(e) => keyPress(e)}
                            onChange={(value) => {
                                card_input({
                                    key: "number",
                                    value: validation({ value, type: "number" })
                                });
                            }}
                            error_message={t("invalid_card_number")}
                            value={card_list.form.number.value}
                            valid={card_list.form.number.valid}
                            submitted={card_list.submitted}
                            onBlur={() => setActive(null)}
                            onFocus={() => setActive(1)} />
                        <span className="icon-camera"></span>
                    </div>
                    <div className="d-flex w-100 mt-2">
                        <div className={activeInput === 2
                            ? "active-input_card"
                            : styles.input_icons}>
                            <NumberInput
                                placeholder={t("month")}
                                focused={activeInput === 2}
                                onKeyDown={(e) => keyPress(e)}
                                onBlur={() => setActive(null)}
                                onFocus={() => setActive(2)}
                                maxLength="2"
                                error_message={t("invalid_month")}
                                value={card_list.form.exp_month.value}
                                valid={card_list.form.exp_month.valid}
                                submitted={card_list.submitted}
                                onChange={(value) => card_input({
                                    key: "exp_month",
                                    value: validation({ value, type: "month" })
                                })}
                            />
                        </div>
                        <div className={activeInput === 3
                            ? "active-input_card"
                            : styles.input_icons}>
                            <NumberInput
                                placeholder={t("year")}
                                focused={activeInput === 3}
                                onKeyDown={(e) => keyPress(e)}
                                onBlur={() => setActive(null)}
                                onFocus={() => setActive(3)}
                                maxLength="2"
                                error_message={t("invalid_year")}
                                value={card_list.form.exp_year.value}
                                valid={card_list.form.exp_year.valid}
                                submitted={card_list.submitted}
                                onChange={(value) => card_input({
                                    key: "exp_year",
                                    value: validation({ value, type: "year" })
                                })}
                            />
                        </div>
                        <div className={activeInput === 4
                            ? "active-input_card"
                            : styles.input_icons}>
                            <NumberInput
                                placeholder={t("cardCVVCodeLabel")}
                                focused={activeInput === 4}
                                onKeyDown={(e) => keyPress(e)}
                                error_message={t("invalid_CVV2")}
                                value={card_list.form.cvc.value}
                                valid={card_list.form.cvc.valid}
                                submitted={card_list.submitted}
                                maxLength="3"
                                onBlur={() => setActive(null)}
                                onFocus={() => setActive(4)}
                                onChange={(value) => card_input({
                                    key: "cvc",
                                    value: validation({ value, type: "cvc" })
                                })}
                            />
                        </div>
                    </div>
                    <div className={styles.text_inputs_cont}>
                        <TextInput
                            onKeyDown={(e) => keyPress(e)}
                            value={card_list.form.name.value}
                            valid={card_list.form.name.valid}
                            submitted={card_list.submitted}
                            label={t("cardHolderNameLabel")}
                            onChange={(value) => {
                                card_input({
                                    key: "name",
                                    value: validation({ value, type: "text" })
                                });
                            }}
                            type="text" />
                        <TextInput
                            onKeyDown={(e) => keyPress(e)}
                            value={card_list.form.email.value}
                            valid={card_list.form.email.valid}
                            submitted={card_list.submitted}
                            label={t("cardInvoicingEmailLabel")}
                            onChange={(value) => {
                                card_input({
                                    key: "email",
                                    value: validation({ value, type: "email" })
                                });
                            }}
                            type="email" />
                        {!card_list.form.email.valid && card_list.form.email.value.length > 0 && card_list.submitted
                            ? <div className={styles.phone_error}>Invalid email</div>
                            : null}
                        <div className={focus ? `${styles.input_focus}` : `${styles.add_card_phone_input}`
                        }>
                            <span className={styles.label}>{t("phoneNumberLabel")}</span>
                            <PhoneInputComponent
                                placeholder="+7 (____)"
                                value={card_list.form.phone_number.value}
                                isValid={(inputNumber, country, countries) => {
                                    validation({ value: inputNumber, country, countries, type: "phone_number" });
                                }}
                                onChange={(value, currentCountryCode) => {
                                    card_input({
                                        key: "phone_number",
                                        value: validation({ currentCode: currentCountryCode, value, type: "phone_number" })
                                    });
                                }}
                                onFocus={() => setFocus(true)}
                                onBlur={() => setFocus(false)}
                            />
                            <div className={styles.line}></div>
                            {!card_list.form.phone_number.valid && card_list.submitted && card_list.form.phone_number.value.length > 4
                                ? <div className={styles.phone_error}>Invalid phone number</div>
                                : null}
                        </div>
                        {/* <TextInput
                            value={card_list.form.phone_number.value}
                            valid={card_list.form.phone_number.valid}
                            submitted={card_list.submitted}
                            onChange={(value) => {
                                card_input({ key: "phone_number", value: validation({ value, type: "phone_number" }) })
                            }}
                            label="Номер телефона"
                            type="number" /> */}
                    </div>
                    {card_list.status === 500
                        ? <div className={styles.status_error}>{t("invalid_card_number")}</div>
                        : null}
                    <span className={styles.title}>{t("cardActionInfoTextLabel")}</span>
                    <MainButton
                        disabled={card_list.create_loading}
                        onClick={() => {
                            add_card();
                        }} title={card_list.create_loading
                            ? <ClipLoader color="#464646" size={15} />
                            : t("addCardLabel")} />
                </div>
            </main>
        </MainLayout>
        // </div>
    );
}
// AddCard.getInitialProps = async (ctx) => {
//     const { token, master } = cookies(ctx);
//     if (!token) {
//         return { loggedIn: false }
//     }
//     return {
//         token,
//         loggedIn: true,
//         stripe: ctx.query.stripe,
//         status: ctx.query.status,
//         master
//     }

// };
export default AddCard;
